// extracted by mini-css-extract-plugin
module.exports = {"AdSlotOffsite":"bgv_a bht_bi"};